import { Paylines } from "@quest/murka-games-behavior-leopard/dist"
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { delayedCall, dispatcher, IEvent, killDelayedCall ,ingenuity} from "@quest/base-core";

import { GameParserModel } from "../Platform/GameParserModel";

export class PaylinesGame extends Paylines {

    /**
     * This methos is use to show win paylines along with win frames on it
     */
    protected showAllPaylineWinframes(evt: IEvent) {
        Paylines.winCycleComplete = 0;
        this.secondToggleStart = false;
        let display: number = arguments[2] || true;
        let callback: number;
        let callbackScope = this;
        let delayTimer: number;
        if (typeof evt === "function") {
            callback = evt;
        }
        else {
            callback = evt.data.callback;
            callbackScope = evt.data.callbackScope;
            delayTimer = evt.data.delayTimer;
            display = evt.data.display;
        }
        killDelayedCall(SlotConstants.SpaghettiDisplayTimer);
        let winLines = this.model.winningLines, winLinesLen = winLines.length;
        let uniquePos: any[] = [];
        if (winLines && winLinesLen) {
            for (let i: number = 0; i < winLinesLen; i++) {
                let pos: number[] = [];
                if (winLines[i].id < this.startIndex) {
                    continue;
                }
                if (display || this.isSpaghetti) {
                    for (let k: number = 0; k < winLines[i].positions.length; k++) {
                        if (!this.findStickyWildWinSymbolFgOffSet(winLines[i].positions[k])) {
                            if (uniquePos.indexOf(winLines[i].positions[k].join("_")) < 0) {
                                pos.push(k);
                                uniquePos.push(winLines[i].positions[k].join("_"));
                            }
                        }
                    }
                    this.showSpecificPaylineWinbox(winLines[i].id, pos);
                }
            }
            this.model.spagettiVisible = true;
            (typeof callback === "function") && (delayedCall(SlotConstants.SpaghettiDisplayTimer, delayTimer, callback, callbackScope));
            this.lineCount = 0;
        }
        else {
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
                dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
            }
            else {
                dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
            }
        }
    }
    /**
    * Find sticky symbol offset
    */
    private findStickyWildWinSymbolFgOffSet(winOffSet: number[]): boolean {
        let flag: boolean = false;
        if ((ingenuity.parserModel as GameParserModel).getIsStickyWildAvailable() &&( (ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining()!== (ingenuity.parserModel as GameParserModel).getFreeSpinNum())) {
            const stickyWildPos: number[] = (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()]
            if (stickyWildPos) {
                for (let index = 0; index < stickyWildPos.length; index++) {
                    if (winOffSet[0] === (stickyWildPos[index] - 1)) {
                        flag = true;
                        break;
                    }
                }
            }
        }
        return flag;
    }
}